<template>
    <div>
        <v-text-field
                v-model="formData.handler"
                disabled
                label="Export"
                required
                :error-messages="handlerErrors"
                @input="$v.formData.handler.$touch()"
                @blur="$v.formData.handler.$touch()"
        ></v-text-field>
        <v-text-field
                v-model="formData.params.year"
                label="Entry Year"
                :mask="'####'"
                required
                :error-messages="paramsYearErrors"
                @input="$v.formData.params.year.$touch()"
                @blur="$v.formData.params.year.$touch()"
        ></v-text-field>
        <v-select
                v-model="formData.params.type"
                :items="entryTypes"
                label="Entry Type"
                required
                :error-messages="paramsTypeErrors"
                @input="$v.formData.params.type.$touch()"
                @blur="$v.formData.params.type.$touch()"
        ></v-select>
        <v-text-field
                v-model="formData.params.targetName"
                label="Target Name"
                :counter="30"
                required
                :error-messages="paramsTargetNameErrors"
                @input="$v.formData.params.targetName.$touch()"
                @blur="$v.formData.params.targetName.$touch()"
        ></v-text-field>
    </div>
</template>

<script>
  import {FieldsMixin} from '@/forms/mixins'
  import {required, minLength, maxLength} from 'vuelidate/lib/validators'

  // NOTE: the FieldsMixin provides the validation and update logic to notify the parent form
  export default {
    name: 'ExportResultsFields',
    mixins: [FieldsMixin],
    data: () => ({
      formData: {
        handler: 'exports.entries_full',
        params: {
          year: 0,
          type: 'GT',
          targetName: 'gff_results.xlsx'
        }
      },
      entryTypes: [
        'GT',
        'WC'
      ]
    }),
    validations: {
      formData: {
        handler: {
          required
        },
        params: {
          year: {
            required,
            validYear: function (value) {
              return value && /^[0-9]{4}$/.test(value)
            }
          },
          type: {
            required,
            validType: function (value) {
              return this.entryTypes.includes(value)
            }
          },
          targetName: {
            required,
            validTargetName: function (value) {
              return value && /^\w{3,26}\.xlsx$/.test(value)
            }
          }
        }
      }
    },
    computed: {
      handlerErrors () {
        // TODO: validate that this is always 'exports.orders'?
        const errors = []
        if (!this.$v.formData.handler.$dirty) return errors
        !this.$v.formData.handler.required && errors.push('Handler is required.')
        return errors
      },
      paramsYearErrors () {
        const errors = []
        if (!this.$v.formData.params.year.$dirty) return errors
        !this.$v.formData.params.year.required && errors.push('Entry year is required.')
        !this.$v.formData.params.year.validYear && errors.push('Entry year must be formatted YYYY e.g. 2018')
        return errors
      },
      paramsTypeErrors () {
        const errors = []
        if (!this.$v.formData.params.type.$dirty) return errors
        !this.$v.formData.params.type.required && errors.push('Entry type is required.')
        !this.$v.formData.params.type.validType && errors.push('Entry type must be one of the values in the list')
        return errors
      },
      paramsTargetNameErrors () {
        const errors = []
        if (!this.$v.formData.params.targetName.$dirty) return errors
        !this.$v.formData.params.targetName.required && errors.push('Target name is required.')
        !this.$v.formData.params.targetName.validTargetName && errors.push('Target Name must be 30 characters or less, and end in ".xlsx"')
        return errors
      }
    },
    methods: {
      setFormDefaults () {
        const self = this
        const todaysDate = new Date()
        self.formData.params.year = todaysDate.getFullYear()
      }
    }
  }
</script>

<style scoped>

</style>
